import cabData from './cabData';

const intialState = [...cabData];

const GET_CABS = 'GET_CABS';

const fetchCabs = () => (dipatch) => {
  // axios.get(API).then((res) => {
  // let packages = [];
  const cabs = intialState;
  dipatch({
    type: GET_CABS,
    cabs,
  });
  // });
};

// eslint-disable-next-line default-param-last
const cabReducer = (state = intialState, action) => {
  switch (action.type) {
    case GET_CABS:
      return [
        ...action.cabs,
      ];
    default:
      return state;
  }
};

export default cabReducer;
export { fetchCabs };
